import { MediaItem } from "../../../../Media.types";

interface Props {
  status: MediaItem["status"];
  setPendingAction: React.Dispatch<
    React.SetStateAction<"VERIFY" | "REJECT" | null>
  >;
  setShowRejectModal: React.Dispatch<React.SetStateAction<boolean>>;
  published?: boolean;
}

const MediaStatusSection: React.FC<Props> = ({
  status,
  setPendingAction,
  setShowRejectModal,
  published,
}) => {
  switch (status) {
    case "VERIFICATION_PENDING":
      return (
        <div className="flex gap-3 justify-center">
          <button
            className="flex-1 py-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition"
            onClick={() => {
              setPendingAction("VERIFY");
            }}
          >
            Verify
          </button>

          <button
            className="flex-1 py-2 rounded-lg border border-red-300 text-red-600 hover:bg-red-50 transition"
            onClick={() => {
              setShowRejectModal(true);
            }}
          >
            Reject
          </button>
        </div>
      );

    case "REJECTED":
      return (
        <div className="flex gap-3 items-start rounded-lg border border-red-200 bg-red-50 p-4">
          <div className="text-red-600 text-xl">⚠️</div>
          <div>
            <p className="text-red-700 font-semibold">Media Rejected</p>
            <p className="text-sm text-red-600 mt-1">
              <span className="font-medium">Reason:</span> No reason provided yet
            </p>
          </div>
        </div>
      );

    case "VERIFIED":
      return (
        <div className="flex flex-col gap-2">
          <div className="flex gap-3 items-start rounded-lg border border-green-200 bg-green-50 p-4">
            <div className="text-green-600 text-xl">✅</div>
            <div>
              <p className="text-green-700 font-semibold">Media Verified</p>
              <p className="text-sm text-green-600 mt-1">
                This media has already been approved.
              </p>
            </div>
          </div>

          {published ? (
            <span className="text-sm text-green-400 m-auto">Media is a part of campaign</span>
          ) : (
            <button
              className="flex-1 py-2 w-full rounded-lg border border-red-300 text-red-600 hover:bg-red-50 transition"
              onClick={() => {
                setShowRejectModal(true);
              }}
            >
              Reject
            </button>
          )}
        </div>
      );

    default:
      return null;
  }
};

export default MediaStatusSection;
